import * as _ from 'lodash';
import { Component, ElementRef, Input, OnDestroy } from '@angular/core';

@Component({
    selector: 'fc-back-to-top-button',
    templateUrl: './back-to-top-button.component.html',
    styleUrls: ['./back-to-top-button.component.less'],
    standalone: false
})
export class BackToTopButtonComponent implements OnDestroy {
    @Input() pageContainerName: string;
    @Input() pageTopAnchorName: string;

    public windowScrolled: boolean;
    private intersectionObserver: IntersectionObserver;
    private topAnchorElement: ElementRef<HTMLDivElement>;

    ngOnDestroy(): void {
        if (this.topAnchorElement?.nativeElement) {
            this.intersectionObserver.unobserve(this.topAnchorElement?.nativeElement);
        }
    }

    public initializeBackToTopButton(topAnchorElement: ElementRef<HTMLDivElement>) {
        this.intersectionObserver = new IntersectionObserver((intersections, intersectionObserver) => {
            if (intersections.length !== 1) {
                this.windowScrolled = false;
                return;
            }
            this.windowScrolled = !intersections[0].isIntersecting;
        });

        this.intersectionObserver.observe(topAnchorElement.nativeElement);
        this.topAnchorElement = topAnchorElement;
    }

    public scrollToTop() {
        if (this.windowScrolled) {
            let targetElement: HTMLElement = document.querySelector(`#${this.pageContainerName}`);

            if (!targetElement) {
                targetElement = document.querySelector(`.${this.pageContainerName}`);
            }

            targetElement.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
}
